<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon ionic-md-paper_bk.png" alt width="27.3" height="27.3" />
      <p class="title-bk">
        テスト対策プリント作成（中学生向け）
      </p>
    </div>
    <div class="container">
      プリントに載せる問題を選択して [追加する]を押してください
      <table class="table">
        <tbody>
          <tr>
            <td width="25%">
              <v-select
                tag="div"
                v-model="currentTestPreparationPrint.book"
                placeholder="級・グレード"
                class="select-control"
                :clearable="false"
                :options="listOfBooksForTestPreparationOptions"
                label="name"
                @input="pickedBook"
              />
            </td>
            <td width="25%">
              <v-select
                tag="div"
                v-model="currentTestPreparationPrint.bookPart"
                placeholder="分野"
                class="select-control"
                :clearable="false"
                :options="bookParts"
                label="name"
                @input="pickedBookPart"
              />
            </td>
            <td width="25%">
              <v-select
                tag="div"
                v-model="currentTestPreparationPrint.bookChapter"
                placeholder="単元"
                class="select-control"
                :clearable="false"
                :options="bookChapters"
                label="name"
                @input="pickedBookChapter"
              />
            </td>
            <td width="25%">
              <v-select
                tag="div"
                v-model="currentTestPreparationPrint.bookBigQuestion"
                placeholder="大問"
                class="select-control"
                :clearable="false"
                :options="bookBigQuestionsWithAllOption"
                label="code"
                @input="pickedBookBigQuestion"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center container container-invisible">
      <button :disabled="!canAddMoreQuestions" class="btn-image ml-auto" @click="addPrint">
        <img src="@/assets/images/Icon ionic-md-arrow-dropleft.png" />
        <label :class="[canAddMoreQuestions ? 'overlay-label' : 'overlay-label-disabled']">追加する</label>
      </button>
    </div>
    <div class="container">
      追加した問題
      <div>
        <b-table ref="test-print-table" responsive sticky-header :items="testPreparationPrints" :fields="fields">
          <template v-slot:head()="scope">
            <div class="text-nowrap">
              <b>{{ scope.label }}</b>
            </div>
          </template>

          <template v-slot:cell(index)="row">
            {{ row.index + 1 }}
          </template>

          <template v-slot:cell(book)="row">
            {{ row.value.name }}
          </template>

          <template v-slot:cell(bookPart)="row">
            {{ row.value.name }}
          </template>

          <template v-slot:cell(bookChapter)="row">
            {{ row.value.name }}
          </template>

          <template v-slot:cell(bookBigQuestion)="row">
            {{ row.value.code }}
          </template>

          <template v-slot:cell(action)="row">
            <a class="hyper-text" @click="deletePrint(row.item.questionIndex)">削除</a>
          </template>
        </b-table>
      </div>
      <label class="label lb-red">
        ※ 大問を{{ minNumOfQuestions }}個以上選択して追加してください（最大{{ maxNumOfQuestions }}個まで）
      </label>
      <div class="d-flex">
        <button
          type="button"
          :disabled="!canProceedWithSelectedQuestions"
          class="btn-red ml-auto"
          @click="exportMultipleTestPrint"
        >
          作成
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import store from '@/store/index.js';

export default {
  data() {
    return {
      fields: [
        {
          key: 'index',
          label: 'No',
        },
        {
          key: 'book',
          label: '級・グレード',
        },
        {
          key: 'bookPart',
          label: '分野',
        },
        {
          key: 'bookChapter',
          label: '単元',
        },
        {
          key: 'bookBigQuestion',
          label: '大問',
        },
        {
          key: 'action',
          label: '',
        },
      ],
      currentTestPreparationPrint: {},
      questionIndex: 1,
    };
  },
  created() {
    this.currentTestPreparationPrint = this.createFreshTestPreparationPrintObject();
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch('test_preparation_print/clearTestPreparationPrints');
    store.dispatch('teacher/fetchAllTamaiClasses', { data: { needBothMainAndSub: true } });
    store.dispatch('book/fetchBooks').then(() => {
      next();
    });
  },
  computed: {
    canAddMoreQuestions() {
      return (
        this.currentTestPreparationPrint.book &&
        this.currentTestPreparationPrint.bookPart &&
        this.currentTestPreparationPrint.bookChapter &&
        this.currentTestPreparationPrint.bookBigQuestion &&
        this.testPreparationPrints.length < this.maxNumOfQuestions
      );
    },
    canProceedWithSelectedQuestions() {
      return (
        this.testPreparationPrints.length >= this.minNumOfQuestions &&
        this.testPreparationPrints.length <= this.maxNumOfQuestions
      );
    },
    listOfBooksForTestPreparationOptions() {
      const listOfBooksForTestPreparation = [];
      const schoolProducts = this.tamaiClasses.map((tamaiClass) => {
        return tamaiClass.school.figuredProducts;
      });
      const figuredProducts = schoolProducts.map((schoolProductList) => {
        return schoolProductList.map((schoolProduct) => {
          return schoolProduct.code;
        });
      });
      let productCodes = [];
      for (const figuredProductList of figuredProducts) {
        for (const figuredProduct of figuredProductList) {
          productCodes.push(figuredProduct);
        }
      }
      for (const book of this.listOfBooksForTestPreparation) {
        const bookTeachingMaterial = this.getTeachingMaterialByCode(book.teachingMaterialCode);
        const bookProductCode = bookTeachingMaterial.productCode;
        if (productCodes.includes(bookProductCode)) listOfBooksForTestPreparation.push(book);
      }
      return listOfBooksForTestPreparation;
    },
    bookBigQuestionsWithAllOption() {
      if (this.bookBigQuestions.length > 0) {
        return [{ id: 'すべて', code: 'すべて', name: null }].concat(this.bookBigQuestions);
      }
      return this.bookBigQuestions;
    },
    ...mapState({
      tamaiClasses: (state) => state.teacher.allTamaiClasses,
    }),
    ...mapState({
      bookParts: (state) => state.book.bookParts,
      bookChapters: (state) => state.book.bookChapters,
      bookBigQuestions: (state) => state.book.bookBigQuestions,
    }),
    ...mapState({
      testPreparationPrints: (state) => state.test_preparation_print.testPreparationPrints,
    }),
    ...mapGetters('test_preparation_print', ['getTestPreparationPrintById', 'minNumOfQuestions', 'maxNumOfQuestions']),
    ...mapGetters('book', ['listOfBooksForTestPreparation']),
    ...mapGetters('teaching_material', ['getTeachingMaterialByCode']),
  },
  methods: {
    pickedBook() {
      this.$logger.debug('Picked Book: ' + this.currentTestPreparationPrint.book.id);
      this.currentTestPreparationPrint.bookPart = null;
      this.currentTestPreparationPrint.bookChapter = null;
      this.currentTestPreparationPrint.bookBigQuestion = null;
      this.currentTestPreparationPrint.bookSmallQuestionSize = null;
      this.fetchBookParts(this.currentTestPreparationPrint.book.id);
    },
    pickedBookPart() {
      this.$logger.debug('Picked Book Part: ' + this.currentTestPreparationPrint.bookPart.id);
      this.currentTestPreparationPrint.bookChapter = null;
      this.currentTestPreparationPrint.bookBigQuestion = null;
      this.currentTestPreparationPrint.bookSmallQuestionSize = null;
      let payload = {
        bookId: this.currentTestPreparationPrint.book.id,
        partId: this.currentTestPreparationPrint.bookPart.id,
      };
      this.fetchBookChapters(payload);
    },
    pickedBookChapter() {
      this.$logger.debug('Picked Book Chapter: ' + this.currentTestPreparationPrint.bookChapter.id);
      this.currentTestPreparationPrint.bookBigQuestion = null;
      this.currentTestPreparationPrint.bookSmallQuestionSize = null;
      let payload = {
        bookId: this.currentTestPreparationPrint.book.id,
        partId: this.currentTestPreparationPrint.bookPart.id,
        chapterId: this.currentTestPreparationPrint.bookChapter.id,
      };
      this.fetchBookBigQuestions(payload);
    },
    pickedBookBigQuestion() {
      this.$logger.debug('Picked Book Big Question: ' + this.currentTestPreparationPrint.bookBigQuestion.id);
      this.currentTestPreparationPrint.bookSmallQuestionSize = null;
    },
    createFreshTestPreparationPrintObject() {
      return {
        book: null,
        bookPart: null,
        bookChapter: null,
        bookBigQuestion: null,
        bookSmallQuestionSize: null,
      };
    },
    addPrint() {
      if (this.currentTestPreparationPrint.bookBigQuestion.code == 'すべて') {
        for (let index = 0; index < this.bookBigQuestions.length; index++) {
          this.addTestPreparationPrint({
            book: this.currentTestPreparationPrint.book,
            bookPart: this.currentTestPreparationPrint.bookPart,
            bookChapter: this.currentTestPreparationPrint.bookChapter,
            bookBigQuestion: this.bookBigQuestions[index],
            bookSmallQuestionSize: this.bookBigQuestions[index].numberOfSmallQuestion,
            questionIndex: this.questionIndex,
          });
          this.questionIndex += 1;
        }
      } else {
        this.currentTestPreparationPrint.questionIndex = this.questionIndex;
        this.addTestPreparationPrint(this.currentTestPreparationPrint);
        this.questionIndex += 1;
      }
      this.currentTestPreparationPrint = this.createFreshTestPreparationPrintObject();
    },
    deletePrint(id) {
      this.$logger.debug('Delete Test Print with Id: ' + id);
      this.deleteTestPreparationPrint(id);
    },
    exportMultipleTestPrint() {
      this.$logger.debug('Export Multiple Test Print processing ...');
      this.createTemplatePdf().then(
        (response) => {
          this.$logger.debug('Success ' + response);
        },
        (error) => {
          this.$logger.debug('Error ' + error);
        }
      );
    },
    ...mapActions('test_preparation_print', ['addTestPreparationPrint', 'deleteTestPreparationPrint']),
    ...mapActions('test_preparation_print', ['createTemplatePdf']),
    ...mapActions('book', ['fetchBooks', 'fetchBookParts', 'fetchBookChapters', 'fetchBookBigQuestions']),
    ...mapActions('teacher', ['fetchAllTamaiClasses']),
  },
};
</script>

<style scoped>
.container-invisible {
  background-color: transparent;
  border-width: 0px;
  margin-bottom: 18px;
  padding: 0px;
}
.overlay-label {
  color: white;
  position: relative;
  cursor: pointer;
  top: -10px;
  left: -184px; /* imageWidth - (imageWidth - labelWidth)/2 */
}
.overlay-label-disabled {
  color: white;
  position: relative;
  cursor: default;
  top: -10px;
  left: -184px; /* imageWidth - (imageWidth - labelWidth)/2 */
}
.lb-red {
  color: red;
  margin-left: 5px;
}
.hyper-text {
  color: #227afa;
  cursor: pointer;
}
.select-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 12px;
}
</style>
